<button
    #menuTrigger="matMenuTrigger"
    (click)="checkUserGuest()"
    (mouseenter)="toggleMenu($event, true)"
    (mouseleave)="toggleMenu($event, false)"
    [matMenuTriggerFor]="viewList"
    class="header-icon"
 
    mat-mini-fab
    matBadgePosition="after"
    id="notificationList"
    [ngClass]="{
      'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  'icons-background' :
      ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
  }"
>
<!-- [ngStyle]="{'background-color' : environmentVariables.HEADER_ICONS_BACKGROUND_COLOR , 'color' : environmentVariables?.HEADER_ICONS_FILL_COLOR}" -->

    <mat-icon
    (mouseover)="changeIconFill=false"
    (mouseleave)="changeIconFill=true" 
    class="material-icons defulat-icons-color"
    [ngClass]="{
      'material-symbols-outlined': (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false) ,
      'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
  }"> notifications </mat-icon>
    <span *ngIf="unreadCount" class="header-icon__badge"
    [ngClass]="{
      'icons-background' :   ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) ,
      'defult-background-icons' : ( !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND )
  }"
    >{{
        unreadCount
    }}</span>
</button>

<mat-menu #viewList="matMenu" [hasBackdrop]="false">
    <ng-container *ngIf="notificationsList?.length; else elseBlock">
        <div
            (mouseenter)="this.enteredMenu = true"
            (mouseleave)="closeMatMenu()"
            class="drop-wrap"
        >
            <div
                *ngFor="let notify of notificationsList; let idx = index"
                [ngClass]="{
                    'new-notification': notify.read == 0,
                    pointer: notify.type != 8
                }"
                class="cart-menu-list p-2"
                (click)="goToDetails(notify)"
                fxLayoutAlign="start center"
            >
                <div *ngIf="notify.image">
                    <a href="javascript:void(0);">
                        <img  loading="lazy" 
                            [src]="notify.image"
                               [alt]="notify.image"
                            default="./assets/images/placeholder200.jpg"
                            onError="this.src='./assets/images/placeholder200.jpg';"
                            style="outline: none; width: 70px"
                            width="70"
                        />
                    </a>
                </div>
                <div class="px-3">
                    <h6 class="my-1 color-brand font-bold">
                        {{
                            lang == "en"
                                ? notify.title
                                : notify.title_ar || notify.title
                        }}
                    </h6>
                    <h6 class="mb-0">
                        {{
                            lang == "en"
                                ? notify.body
                                : notify.body_ar || notify.body
                        }}
                    </h6>
                </div>
            </div>
            <div class="footer-menu px-3 pb-2 pt-2">
                <button
                    (click)="checkUserGuest()"
                    class="w-100 color-primary"
                    color="accent"
                    mat-raised-button
                >
                    {{ "button.viewAll" | translate }}
                </button>
            </div>
        </div>
    </ng-container>
    <ng-template #elseBlock>
        <div
            class="cart-menu-list p-2 empty-list"
            fxLayoutAlign="center center"
        >
            {{
                lang == "en"
                    ? "No Notifications Found."
                    : "لا توجد إشعارات حاليآ "
            }}
        </div>
    </ng-template>
</mat-menu>
